import React from "react"
import { MessageCircle, Instagram } from "lucide-react"

export default function Sessions() {
  const handleWhatsAppMessage = () => {
    const message = encodeURIComponent(
      "Hello, I'm interested in booking a Breathwork & Somatic Coaching session. Can you provide more information?"
    )
    window.open(`https://wa.me/+351965220370?text=${message}`, "_blank")
  }

  const handleInstagramMessage = () => {
    const profileUrl =
      "https://www.instagram.com/luis_breatho/?igsh=MWJnZ2gwemhmZTQ4bQ=="
    window.open(profileUrl, "_blank")
  }

  return (
    <>
      <style jsx global>{`
        @font-face {
          font-family: "Muar-Regular";
          src: url("/fonts/Muar-Regular.ttf") format("truetype");
          font-weight: normal;
          font-style: normal;
        }
        @font-face {
          font-family: "Muar-Stencil";
          src: url("/fonts/Muar-Stencil.ttf") format("truetype");
          font-weight: normal;
          font-style: normal;
        }
      `}</style>
      <div className="container mx-auto px-4 py-12 max-w-5xl">
        <h1 className="text-5xl mb-8 text-center text-purple-800 font-['Muar-Stencil']">
          Breathwork & Somatic Coaching
        </h1>

        <div className="bg-purple-50 p-8 rounded-lg shadow-lg mb-12">
          <p className="text-lg leading-relaxed text-gray-700 font-['Muar-Regular']">
            Over the last 7 years, beathwork and sound healing have been offered
            to all kinds of people, individually or in groups. Keeping in mind
            that we are healthy to the degree we are conscious –{" "}
            <b>and conscious to the degree we are healthy </b>–, make sure to{" "}
            <b>book</b> a session with me. These can also be done online. Click
            the video to know about my 360º Breath Method, or enjoy Breathwork
            the movie.
          </p>
          <div className="flex flex-wrap justify-center gap-4 mt-5">
            <button
              onClick={handleWhatsAppMessage}
              className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full transition duration-300 ease-in-out transform hover:scale-105 flex items-center"
            >
              <MessageCircle className="mr-2" size={24} />
              WhatsApp
            </button>
            <button
              onClick={handleInstagramMessage}
              className="bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-bold py-3 px-6 rounded-full transition duration-300 ease-in-out transform hover:scale-105 flex items-center"
            >
              <Instagram className="mr-2" size={24} />
              Instagram
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
          <div className="aspect-w-16 aspect-h-9 h-0 pb-[56.25%] relative">
            <iframe
              src="https://www.youtube.com/embed/smyxlKCvhBE"
              title="Breathwork Session Video 1"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
            ></iframe>
          </div>
          <div className="aspect-w-16 aspect-h-9 h-0 pb-[56.25%] relative">
            <iframe
              src="https://www.youtube.com/embed/yaw3HagRnVc"
              title="Breathwork Session Video 2"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  )
}
